export default __webpack_public_path__ + "static/media/cont7.40efcc64.png";